import * as React from 'react'
import { AuthContext } from '../context/AuthContext'

const useAuthContext = () => {
    return React.useContext(AuthContext)
}

export default useAuthContext
